import styled from 'styled-components'

import colors, { FLAG_COLOURS } from 'constants/colors'

export const StyledContainer = styled.div`
  min-height: 200px;
  width: 100%;
  position: relative;
  border: 1px solid ${({ $invalid }) => ($invalid ? FLAG_COLOURS.ERROR : colors.lightGray)};
  border-radius: 5px;
  display: flex;

  ${({ $disabled }) => $disabled && `
    cursor: not-allowed;
    pointer-events: none;
    opacity: 0.6;
  `}
`

export const StyledPadContainer = styled.div`
  height: 100%;
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
`

export const StyledTextContainer = styled.div`
  position: absolute;
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
`

export const StyledTextWrapper = styled.div`
  display: flex;
`

export const StyledUnderlineWrapper = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  height: 100%;
  width: 100%;
`

export const StyledUnderline = styled.hr`
  position: absolute;
  width: 90%;
  bottom: 15px;
  border: 0 none;
  border-top: 1px solid ${colors.lightGray};
  background: none;
  height: 0;
`

export const StyledSignaturePadContainer = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
`

export const StyledClearContainer = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
  cursor: pointer;
`
